export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto lg:mx-0">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-6">
            Votre réparateur de fenêtre à Ostwald
          </h2>
          <div className="space-y-4 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Ostwald, à moins de dix minutes de Strasbourg, est une commune résidentielle où immeubles et pavillons se côtoient. Les fenêtres y subissent le vent du Rhin et les variations de température. Nos techniciens interviennent rapidement, pièce comprise, sans remplacer toute la menuiserie.
            </p>
            <p>
              Ostwald, au sud de Strasbourg, est une commune résidentielle très proche de notre atelier. Le parc immobilier est marqué par une forte mixité : immeubles d'habitation collectifs aux fenêtres PVC et aluminium, maisons individuelles et pavillons avec des ouvertures variées. Nous connaissons bien les spécificités de chaque type.
            </p>
            <p>
              Que vous résidiez dans un appartement ou dans une maison individuelle, nous intervenons gratuitement. Nous réparons le mécanisme dans plus de 90 % des cas, sans jamais remplacer la fenêtre entière. C'est plus rapide, plus écologique et bien plus économique. Déplacement et devis gratuits, pièce comprise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}